import { render } from "./CalendarFillingLegend.vue?vue&type=template&id=f8ddfec4&scoped=true"
const script = {}

import "./CalendarFillingLegend.vue?vue&type=style&index=0&id=f8ddfec4&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8ddfec4"]])

export default __exports__